import { useState } from 'react';
import styled from 'styled-components';
//
import { Subtitle, Button, Input, Title } from '../../components/ui';
import Layout from '../../components/Layout';
import { registerCustomer } from '../../api/services/customerService';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContentContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px 0;
  padding: 3rem;
  border: 1px solid ${(props) => props.theme.colors.subBackground};
`;

const FieldContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 3rem;
`;

const InputContainer = styled.div`
  width: 80%;
  border: 1px solid #ccc;
  margin-top: 10px;
  margin-bottom: 30px;
`;

const Row = styled.div`
  width: 80%;
  display: flex;
  justify-content: space-between;
`;

const RemarkInput = styled.textarea`
  box-sizing: border-box;
  font-family: 'Roboto', sans-serif;
  min-width: 80%;
  max-width: 80%;
  min-height: 150px;
  max-height: 300px;
  border: 1px solid #ccc;
  margin-top: 10px;
  margin-bottom: 30px;
  padding: 10px;
  font-size: 1rem;

  overflow: auto;
  &:focus {
    outline: none;
  }
`;

const RegisterPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    password: '',
    firstname: '',
    lastname: '',
    email: '',
    tel: '',
    cellPhone: '',
    fax: '',
    companyNm: '',
    addr: '',
    city: '',
    zipcode: '',
    state: '',
    country: '',
    ein: '',
    bType: '',
    bLicenseNo: '',
    spNo: '',
    remark: '',
  });

  const addDbCustomer = async () => {
    const emptyFields = Object.entries(formData)
      .filter(([, value]) => value === '')
      .map(([key]) => key);

    if (emptyFields.length > 0) {
      alert('All forms must be fill.');
      return null;
    }

    const result = await registerCustomer(formData);
    if (result.is_success) {
      alert(
        'Register Success!\nOne of our customer service reps will get back to you',
      );
      navigate('/');
    } else {
      alert(result.message);
    }
  };

  return (
    <Layout>
      <Container>
        <Title
          style={{
            margin: '80px 0 40px 0',
            whiteSpace: 'pre',
            textAlign: 'center',
          }}
        >
          {'Sign Up'}
        </Title>
        <Subtitle>
          Please fill out the registration form and one of our customer service
          reps will get back to you:
        </Subtitle>
        <ContentContainer>
          <Title style={{ marginTop: '2rem' }}>Your Personal Details</Title>
          <FieldContainer>
            <Row>
              <Subtitle>First name:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.firstname}
                onChange={(e) => setFormData({ ...formData, firstname: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Last name:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.lastname}
                onChange={(e) => setFormData({ ...formData, lastname: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Email (Username):</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Password:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='password'
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Telephone:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.tel}
                onChange={(e) => setFormData({ ...formData, tel: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Mobile phone:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.cellPhone}
                onChange={(e) => setFormData({ ...formData, cellPhone: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Fax:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.fax}
                onChange={(e) => setFormData({ ...formData, fax: e })}
              />
            </InputContainer>
          </FieldContainer>
          <Title style={{ marginTop: '2rem' }}>Company Info</Title>
          <FieldContainer>
            <Row>
              <Subtitle>Company name:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.companyNm}
                onChange={(e) => setFormData({ ...formData, companyNm: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Street/PO Box:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.addr}
                onChange={(e) => setFormData({ ...formData, addr: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>City:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.city}
                onChange={(e) => setFormData({ ...formData, city: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Zip code:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.zipcode}
                onChange={(e) => setFormData({ ...formData, zipcode: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>State:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.state}
                onChange={(e) => setFormData({ ...formData, state: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Country:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.country}
                onChange={(e) => setFormData({ ...formData, country: e })}
              />
            </InputContainer>
            <Row style={{ marginTop: '3rem' }}>
              <Subtitle>EIN # (Federal Tax ID #):</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.ein}
                onChange={(e) => setFormData({ ...formData, ein: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Business Type:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.bType}
                onChange={(e) => setFormData({ ...formData, bType: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Business License #:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.bLicenseNo}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    bLicenseNo: e,
                  })
                }
              />
            </InputContainer>
            <Row>
              <Subtitle>{"Seller's Permit #:"}</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <InputContainer>
              <Input
                type='text'
                value={formData.spNo}
                onChange={(e) => setFormData({ ...formData, spNo: e })}
              />
            </InputContainer>
            <Row>
              <Subtitle>Remarks:</Subtitle>
              <Subtitle>*</Subtitle>
            </Row>
            <RemarkInput
              type='text'
              value={formData.remark}
              onChange={(e) =>
                setFormData({ ...formData, remark: e.target.value })
              }
            />
          </FieldContainer>
          <Button
            style={{ marginTop: '2rem' }}
            onClick={() => {
              addDbCustomer();
            }}
          >
            SUBMIT FORM
          </Button>
        </ContentContainer>
      </Container>
    </Layout>
  );
};

export default RegisterPage;
